var render = function render(){var _vm=this,_c=_vm._self._c;return _c('erp-select',{attrs:{"loading":_vm.loading,"placeholder":_vm.placeholder || 'Nenhum',"options":_vm.asyncdataFiltered,"multiple":_vm.multiple,"simpleBorder":_vm.simpleBorder},on:{"input":_vm.__set},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }